export class inProcessUrl {
    DELETE_IN_PROCESS_ORGANIZER_URL = "org/v1/in-process-organizer/";
    IN_PROCESS_ORGANIZERS_URL = "org/v1/in-process-organizer/all[?Name][&ClientId][&EroSigner][&AssignedTo][&OrganizerStatus][&UploadedAfter][&TaxReturnType][&TaxYear][&PageNo][&PageSize][&SortOrder][&SortBy]"
}